import { useRouteError } from "react-router-dom";

export default function ErrorPage() {
  const error = useRouteError();
  console.error(error);

  return (
    <div className="error-page">
      <h1>Oops!</h1>
      <p>Sorry, an unexpected error has occurred. Check back later!</p>
      <p>
        <i>{error.statusText || error.message}</i>
      </p>
    </div>
  );
}